async function t(t,{request:a}){return await t.fetchPrivyRoute(e,{body:a})}let e={method:"POST",path:"/v1/wallets"};export{t as create};
